<div class="flex items-center gap-x-2">

    <app-button
        [label]="'Venue layout'"
        [disabled]="venueLayout.isAnimating()"
        [active]="venueLayout.showContainer()"
        (event)="venueLayout.toggleContainer()"
    />

</div>